/*
 * @Description: 通用 相关接口
 * @Author: 山淑兰
 * @Date: 2019-09-06 15:53:39
 * @LastEditTime: 2019-09-06 15:57:25
 * @LastEditors: 山淑兰
 */
/**
 * 设置相关接口
 */
// const API_HOST = process.env.VUE_APP_API_HOST

// const API_PATH = {
 
// }
export default {
  
}
